import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Divider } from 'components/ui';
import localeUtils from 'utils/LanguageLocale';
import ProductCompareTool from 'components/ProductPage/ProductCompareTool';
import SimilarProductFilters from './SimilarProductFilters.f';
import { useFilteredRecommendations } from './useFilteredRecommendations';
import bpRedesignedUtils from 'utils/BeautyPreferencesRedesigned';
import recServiceUtils from 'utils/RecommendationService';
import productUtils from 'utils/product';
import pdpCompareUtils from 'utils/pdpCompare';

import { CONSTRUCTOR_PODS } from 'constants/constructorConstants';

const { transformRecommendationsForCarousel } = recServiceUtils;

const SIMPLIFIED_COMPARE_ATTRIBUTES = ['price', 'rating'];

const SimilarProductCarousel = ({ isSmallView, currentProduct, simplifiedCompareVersion }) => {
    const isSimplified = !!simplifiedCompareVersion;
    const podIdOverride = isSimplified ? CONSTRUCTOR_PODS.SIMILAR_PRODUCTS : null;
    const { podId, productRecommendationsData, isFetching, updateFilter } = useFilteredRecommendations(currentProduct, podIdOverride);
    const { recommendations = [], resultId = '', totalNumResults = 0 } = productRecommendationsData;
    const recommendationsForCarousel = transformRecommendationsForCarousel(recommendations);

    if (isSimplified && !isFetching && recommendationsForCarousel.length === 0) {
        return null;
    }

    const featuresData = currentProduct?.cxsContent?.similarProductsComparison?.featuresData;
    const currentPrice = currentProduct?.currentSku?.listPrice;
    const title = localeUtils.isFRCanada() ? 'Produits similaires' : `Similar ${currentProduct?.parentCategory?.displayName}`;
    const parentCategoryId = productUtils.findProductRootParentCategoryId(currentProduct?.parentCategory);
    const masterlistWorld = bpRedesignedUtils.getMasterListRefinementWorldByCategoryId(parentCategoryId);
    const pdpCompareAttributes = isSimplified ? SIMPLIFIED_COMPARE_ATTRIBUTES : pdpCompareUtils.getPdpCompareAttributes(masterlistWorld?.key);

    const similarProductVariants = isSimplified ? null : (
        <SimilarProductFilters
            featuresData={featuresData}
            selectedVariation={podId}
            onFilterChange={updateFilter}
            currentPrice={currentPrice}
        />
    );

    return (
        <Box
            lineHeight='tight'
            marginBottom={[6, 7]}
        >
            <Divider />
            <ProductCompareTool
                skuList={recommendationsForCarousel}
                similarProductVariants={similarProductVariants}
                isLoading={isFetching}
                isSmallView={isSmallView}
                title={title}
                podId={podId}
                resultId={resultId}
                totalResults={totalNumResults}
                isCarousel
                pdpCompareAttributes={pdpCompareAttributes}
                currentProduct={currentProduct}
            />
        </Box>
    );
};

SimilarProductCarousel.propTypes = {
    isSmallView: PropTypes.bool,
    currentProduct: PropTypes.object,
    simplifiedCompareVersion: PropTypes.string
};

export default wrapFunctionalComponent(SimilarProductCarousel, 'SimilarProductCarousel');
